module.exports = "/_next/static/images/introSectionCard4-9374d30509d6387865360b498b70b5f6.svg";